import { atom } from 'jotai'

import { type VehicleDispatchBoardsDrawerMenuType } from '../../-models'

/**
 * 配車板メニューのアクティブ状態
 */
export const activeVehicleDispatchBoardsMenuAtom =
  atom<VehicleDispatchBoardsDrawerMenuType | null>(null)

activeVehicleDispatchBoardsMenuAtom.debugLabel =
  'activeVehicleDispatchBoardsMenuAtom'
